// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-next-event_modal__sZiXa","field":"modal-next-event_field__2bT65","date":"modal-next-event_date__MCkhp","errors":"modal-next-event_errors__1brQu"};